import { RegisteredComponent } from "@builder.io/sdk-react";
import { DLD_FIELD, DLT_FIELD } from "../commonFields";

export const closeButtonBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Close button",
  noWrap: true,
  shouldReceiveBuilderProps: {
    builderContext: true,
  },
  inputs: [DLD_FIELD, DLT_FIELD],
};
